import useGlobalState from '../../../hooks/useGlobalState'
import { cn } from '../../../utils/cn'

export default function HighContrastToggle() {
    const highContrastMode = useGlobalState((state) => state.highContrastMode)
    const setState = useGlobalState((state) => state.setState)

    const toggleHighContrast = () => {
        setState({ highContrastMode: !highContrastMode })
    }

    return (
        <button
            onClick={toggleHighContrast}
            className={cn(
                'bg-white',
                'rounded flex h-12 p-3 items-center justify-center',
                'hover:bg-gray-50 transition-all',
                'focus:outline-none',
                highContrastMode
                    ? 'shadow-[inset_0_0_0_2px_black]'
                    : 'shadow-[inset_0_0_0_1px_#8c8c8c]'
            )}
            type="button"
            aria-pressed={highContrastMode}
            aria-label={
                highContrastMode
                    ? 'Disable high contrast mode for better accessibility'
                    : 'Enable high contrast mode for better accessibility'
            }
            title={
                highContrastMode
                    ? 'Disable high contrast mode'
                    : 'Enable high contrast mode'
            }
        >
            <svg
                width="24"
                height="16"
                viewBox="0 0 24 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="img"
            >
                {/* Left: Black A on white, Right: White A on black */}
                <rect
                    x="0"
                    y="0"
                    width="12"
                    height="16"
                    fill="white"
                    stroke="#333"
                    strokeWidth="0.5"
                />
                <text
                    x="6"
                    y="12"
                    textAnchor="middle"
                    fill="black"
                    fontSize="10"
                    fontFamily="Arial, sans-serif"
                    fontWeight="bold"
                >
                    A
                </text>

                <rect
                    x="12"
                    y="0"
                    width="12"
                    height="16"
                    fill="black"
                    stroke="#333"
                    strokeWidth="0.5"
                />
                <text
                    x="18"
                    y="12"
                    textAnchor="middle"
                    fill="white"
                    fontSize="10"
                    fontFamily="Arial, sans-serif"
                    fontWeight="bold"
                >
                    A
                </text>
            </svg>
        </button>
    )
}
